import get from 'lodash/get'
import sumBy from 'lodash/sumBy'
import { addYears } from 'date-fns'
import numeral from 'numeral'
// import URL from 'url';

export const getTheme =
  ([path]) =>
  (props) =>
    get(props, `theme.${path}`)

export const formatComma = (number = '') => numeral(number).format('0,0')

export const formatCommaDecimal = (number = '') => numeral(number).format('0,0.00')

export const formatThaiDuration = (duration) => {
  const hours = Math.floor(duration / 3600)
  const hourString = hours ? `${hours} ชั่วโมง ` : ''
  const minutes = Math.floor(duration / 60) % 60
  const minuteString = hours || minutes ? `${minutes} นาที ` : ''
  const seconds = duration % 60
  return `${hourString}${minuteString}${seconds} วินาที`
}

export const uploadToS3 = ({ url, file, contentType, contentEncoding }) => {
  let xhr = new XMLHttpRequest() // eslint-disable-line
  xhr.open('PUT', url, true)
  if (contentType) {
    xhr.setRequestHeader('Content-Type', contentType)
  }
  xhr.send(file)
  return new Promise((resolve, reject) => {
    xhr.onload = (e) => {
      console.log(e, xhr)
      if (xhr.status === 200) {
        resolve(url.split('?')[0])
      } else {
        reject(xhr.status)
      }
    }
  })
}

export const viewportWidth = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const viewportHeight = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export const tableWidth = (columns) => sumBy(columns, 'width')

export const toBase64 = (_file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader() // eslint-disable-line
    reader.readAsDataURL(_file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const uncoverImage = ({ backup, image }) => {
  return backup ? image.replace('.jpg', '_uncover.jpg') : image
}

/**
 * Convert date string from Buddhist date with `DD-MM-YY` to `YYYY-MM-DD` with Christian date
 * @param {String} thDate Date string in format `DD-MM-YY` with buddhist year e.g. 25-03-65
 * @returns Date with format `YYYY-MM-DD` with Christian year
 */
export const transformBuddhistDateToChristianDate = (thDate) => {
  // thDate : DD-MM-YY (ex: 20-01-65)
  const date = thDate.split('-')
  let day = parseInt(date[0])
  let month = parseInt(date[1])
  let year = parseInt(date[2])
  // Convert Buddhist year to Christian year
  if (year >= 43) {
    year = year - 43
  } else {
    year = year + 57
  }

  const formattedDate = addYears(new Date(year, month - 1, day), 100)
  return formattedDate
}

export const toISOStringWithTimezone = (date) => {
  const tzOffset = -date.getTimezoneOffset()
  const diff = tzOffset >= 0 ? '+' : '-'
  const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    diff +
    pad(tzOffset / 60) +
    ':' +
    pad(tzOffset % 60)
  )
}

export function addDays(date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}
